import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'app-bitcoin-app',
    templateUrl: './bitcoin-app.component.html',
    styleUrls: ['./bitcoin-app.component.scss']
})
export class BitcoinAppComponent implements OnInit, OnDestroy {

    @Input() show = false;
    @Input() src = '';

    @Output('onClose') emitClose: EventEmitter<any> = new EventEmitter();

    safeUrl;
    activeClass = false;
    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit(): void {
      this.activeClass = true;
      this.safeUrl = this.getUrl();
    }

    ngOnDestroy() {
      this.activeClass = false;
    }

    handleClose(): void {
        this.emitClose.emit();
    }

    getUrl() {
      return this.sanitizer.bypassSecurityTrustResourceUrl(this.src);
    }

}
